export default {
  GET_ANALYZE_CONTINUE_REPORT: "/api/v1/analyze/continue/simple",
  GET_ANALYZE_CONTINUE_SUBSCRIBE: "/api/v1/analyze/continue/report",

  //brook
  POST_BROOK_TRACKING_EVENT: "/api/v1/brook/tracking/event",
  POST_BROOK_MATCH_EVENT: "/api/v1/brook/match/event",
  POST_BROOK_CAMPAIGN: "/api/v1/brook-campaign",
};
